import { useTranslation } from 'react-i18next';

import MessengerLink, { MESSAGE_ICON_SIZE } from 'components/common/MessengerLink';
import { CONTACT_MESSENGERS, MESSENGER_LABEL } from 'helpers/messengers';

/** Мессенджер в том виде, в котором его отдаёт API сотрудников */
interface EmployeeMessenger {
  id: string;
  /** Тип мессенджера: telegram, whatsapp, viber, vkmax */
  value: string;
  /** Логин или номер, указанный сотрудником */
  messenger: string;
}

interface EmployeeMessengersProps {
  messengers?: Array<EmployeeMessenger> | null;
  size?: string;
  /** Класс контейнера — раскладка отличается в таблице и в мобильной карточке */
  className?: string;
}

/**
 * Выводит весь набор мессенджеров: заполненные — цветной ссылкой, незаполненные — серой иконкой,
 * чтобы по строке сотрудника сразу было видно, каких контактов не хватает.
 */
const EmployeeMessengers = ({
  messengers,
  size = MESSAGE_ICON_SIZE.small,
  className,
}: EmployeeMessengersProps) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      {CONTACT_MESSENGERS.map((type) => {
        const filled = (messengers || []).find((messenger) => messenger.value === type);
        const label = MESSENGER_LABEL[type] || type;

        if (!filled) {
          return (
            <MessengerLink
              key={type}
              item={{ type }}
              size={size}
              disabled={true}
              title={t('employee.messengerNotFilled', { messenger: label })}
            />
          );
        }

        return (
          <MessengerLink
            key={type}
            item={{ type, login: filled.messenger }}
            size={size}
            title={`${label}: ${filled.messenger}`}
          />
        );
      })}
    </div>
  );
};

export default EmployeeMessengers;
